/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IConsumable } from 'app/shared/model/consumable.model';
import { IImplant } from 'app/shared/model/implant.model';
import { ITemplatePrescription } from 'app/shared/model/template-prescription.model';
import { TemplateItemType } from 'app/shared/model/enumerations/template-item-type.model';

export interface ITemplateMedication {
  id?: string;
  repetition?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  prescribedCount?: number;
  indication?: string;
  daysFrequency?: string | null;
  endDate?: number;
  dose?: string | null;
  route?: string | null;
  templateItemType?: keyof typeof TemplateItemType | null;
  medicineName?: string | null;
  doseInstructions?: string | null;
  tmType?: string;
  consumable?: IConsumable | null;
  implant?: IImplant | null;
  prescription?: ITemplatePrescription | null;
}

export const defaultValue: Readonly<ITemplateMedication> = {
  active: false,
};
